import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PersonalWebsite from './Home';
import BlogList from './blog/BlogList';
import BlogPost from './blog/BlogPost';
import Rowly from './Rowly';
import RowlyPrivacy from './RowlyPrivacy';
import BuildBetter from './BuildBetter';
import BuildBetterPrivacy from './BuildBetterPrivacy';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<PersonalWebsite />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/rowly" element={<Rowly />} />
        <Route path="/rowly/privacy" element={<RowlyPrivacy />} />
        <Route path="/build-better" element={<BuildBetter />} />
        <Route path="/build-better/privacy" element={<BuildBetterPrivacy />} />
      </Routes>
    </Router>
  );
}

export default App;
